import * as moment from 'moment';
import 'moment/locale/fr'  

export const validateEmail = (email) => {
  // eslint-disable-next-line
  var re = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,7}$/i;
  return re.test(String(email).toLowerCase());
}

export function formatInputDate(inputDate) {
  if(!inputDate) return '';
  const date = new Date(inputDate);
  return new Intl.DateTimeFormat('en-US').format(date);

}

export function isValidDate(d) {
  return d instanceof Date && !isNaN(d);
}

export function translateDate(date , lang ) {
  var newDate = moment(date)
  moment.locale(lang)
  return  newDate.format('LLLL'); // 'Freitag, 24. Juni 2016 01:42'
}

export function triAlpha(a,b)  {
  return (a.name > b.name)? 1:-1;
};

export function triCloison(a,b)  {
  return (a.showroomOption.shape > b.showroomOption.shape )? 1:-1;
};

export function triCentrale(a,b)  {
  return (a.centrale > b.centrale )? 1:-1;
};

export function calculPrice(data){
  let obj = {}
  let total = 0;
  const initPrices = {
    storage: 45,
    power: 230,
    water: 330
  }
  
  if(data.option && data.dimension && data.option.direction ) {
    let dimension = data.dimension
    total = (dimension/6) * 5400
  }

  if(data.option &&
    data.option.customDimension &&
    data.option.customDimension.l &&
    data.option.customDimension.L
  ){
    let dimension = data.option.customDimension.l*data.option.customDimension.L
    // (dimension%6) * 1000 // supplement de 1000€ par 1m
    // (Math.floor(dimension/6))*4500 // supplement de 1000€ par 1m²
    total =  ((Math.floor(dimension/6))*5400) + (dimension%6) * 1000
  }

  if(data.option &&
    data.option.storageSize){
    obj.storagePrice = data.option.storageSize * initPrices.storage
    total = total + (data.option.storageSize * initPrices.storage)
  }

  if(data.option &&
    data.option.power){
    total = total + initPrices.power
    obj.powerPrice = initPrices.power
  }

  if(data.option &&
    data.option.water){
    total = total + initPrices.water
    obj.waterPrice = initPrices.water
  }
  obj.total = total
  return obj

}

export function calcOrderTotal(productArray) {
  let total = 0;
  productArray.forEach(product => {
    let pack = parseFloat(product.packing) ? parseFloat(product.packing) : 1 ;
    if (product.price) {
      total += product.price * pack
    }
  });
  return total.toFixed(2)
} 

export function calcOfferPrice(offer) {
  let total = 0;
  let pack = parseFloat(offer.packing) ? parseFloat(offer.packing) : 1 ;
  if (offer.price) {
    total += offer.price * pack
  }
  if (offer.quantity) {
    total = total * offer.quantity;
  }
  return total.toFixed(2)
}

export const toBase64 = (file) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = () => resolve(reader.result);
  reader.onerror = reject;
});
